import { render, staticRenderFns } from "./ContentVersionEditor.vue?vue&type=template&id=7257b180&"
import script from "./ContentVersionEditor.vue?vue&type=script&lang=ts&"
export * from "./ContentVersionEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports